import { createIcon } from "@chakra-ui/react";

export const Question = createIcon({
  displayName: "Question",
  viewBox: "0 0 24 24",
  d: "M12 0C5.372 0 0 5.372 0 12s5.372 12 12 12 12-5.372 12-12S18.628 0 12 0zm0 21.75c-5.377 0-9.75-4.374-9.75-9.75S6.623 2.25 12 2.25s9.75 4.374 9.75 9.75-4.373 9.75-9.75 9.75zm0-6c-.844 0-1.5.656-1.5 1.5s.614 1.5 1.5 1.5c.802 0 1.5-.656 1.5-1.5s-.698-1.5-1.5-1.5zM13.552 6h-2.396a3.261 3.261 0 0 0-3.281 3.281c0 .61.516 1.125 1.125 1.125a1.14 1.14 0 0 0 1.125-1.125c0-.562.427-1.031.99-1.031h2.394c.605 0 1.116.469 1.116 1.031 0 .375-.188.661-.516.849l-2.671 1.636c-.376.234-.563.609-.563.984v.75c0 .61.516 1.125 1.125 1.125a1.14 1.14 0 0 0 1.125-1.125v-.094l2.114-1.312c.984-.61 1.594-1.688 1.594-2.813C16.875 7.453 15.422 6 13.552 6z",
  defaultProps: {
    "aria-label": "A question mark within a hollow circle"
  }
});

export default Question;
